import { Building2, TrendingUp, RefreshCw, Globe2, Handshake, PiggyBank } from 'lucide-react';
import type { Skill } from '../types/content';

export const skills: Skill[] = [
  {
    icon: Building2,
    title: 'Enterprise & P&L Leadership',
    description: 'Full accountability for enterprise performance and financial outcomes.'
  },
  {
    icon: TrendingUp,
    title: 'Corporate Strategy & Commercial Growth',
    description: 'Shaping strategic direction and commercial growth across complex organizations.'
  },
  {
    icon: RefreshCw,
    title: 'Business & Operational Transformation',
    description: 'Leading enterprise-wide transformation and operating model redesign.'
  },
  {
    icon: Globe2,
    title: 'International Business Development (EMEA, Americas, APAC)',
    description: 'Scaling commercial reach and market presence across global regions.'
  },
  {
    icon: Handshake,
    title: 'Strategic Partnerships, M&A & Joint Ventures',
    description: 'Structuring alliances and transactions that create lasting commercial value.'
  },
  {
    icon: PiggyBank,
    title: 'Financial Stewardship & Capital Allocation',
    description: 'Disciplined allocation of capital and resources across the enterprise.'
  }
];
